import { useState, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isSuperAdmin } from '../constants/roles';

const MODAL_DISMISS_KEY = 'boostModalLastDismissed';
const MODAL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const useBoostModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { user } = useAuth();

  useEffect(() => {
    // Don't show modal for super admin role
    if (isSuperAdmin(user?.role)) {
      setIsOpen(false);
      return;
    }

    // Check for viewBenefits param - if present, don't show modal
    const viewBenefits = searchParams.get('viewBenefits');
    const hotelId = searchParams.get('hotelId');

    if (location.pathname === '/upgrade') {
      // Don't show modal if viewBenefits=true or hotelId is present
      if (viewBenefits === 'true' || hotelId) {
        setIsOpen(false);
      } else {
        // Direct visit to /upgrade without params - show modal
        setIsOpen(true);
      }
      return;
    }

    // Close modal on other pages
    setIsOpen(false);

    // For home page, check if we should show based on time
    // if (location.pathname === '/') {
    //   const lastDismissed = localStorage.getItem(MODAL_DISMISS_KEY);

    //   if (!lastDismissed) {
    //     // First time - show modal
    //     setIsOpen(true);
    //   } else {
    //     const lastDismissedTime = parseInt(lastDismissed, 10);
    //     const timeSinceLastDismiss = Date.now() - lastDismissedTime;

    //     // Show modal if 5 minutes have passed since last dismissal
    //     if (timeSinceLastDismiss >= MODAL_INTERVAL_MS) {
    //       setIsOpen(true);
    //     }
    //   }
    // }
  }, [location.pathname, user?.role, searchParams]);

  const handleClose = () => {
    setIsOpen(false);

    // Only save dismissal time if not on /upgrade page
    if (location.pathname !== '/upgrade') {
      localStorage.setItem(MODAL_DISMISS_KEY, Date.now().toString());
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  return {
    isOpen,
    onClose: handleClose,
    onOpen: handleOpen,
  };
};
